/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { getData } from "../../Services/getData";
import { urlEnum } from "../../Utils/UrlEnum";
import { Vocabulary } from "../../Utils/Vocabulary";

type OrdersAutocompleteProps = {
  parentOrder: any;
  handleChangeOrderInParent: (event: any, value: any) => void;
};
export default function OrdersAutocomplete(props: OrdersAutocompleteProps) {
  const { parentOrder, handleChangeOrderInParent } = props;
  const [orders, setOrders] = useState([]);
  const [order, setOrder] = useState<string>("");

  /**
   *
   */
  useEffect(() => {
    getOrders(null);
  }, []);

  /**
   *
   */
  function getOrders(search: string | null) {
    getData(`${urlEnum.orders}/search/${search}`).then((res: any) => {
      if (res && res.data && res.data.result) setOrders(res.data.result);
    });
  }

  /**
   *
   * @param event
   * @param value
   */
  function handleChangeOrder(event: any, value: any) {
    handleChangeOrderInParent(event, value);
    setOrder("");
    getOrders(null);
  }

  return (
    <>
      <Autocomplete
        size="small"
        id="order"
        freeSolo={false}
        disablePortal
        getOptionLabel={(option: any) => {
          return option.orderNumber?.toString() || option.orderNumber?.toString();
        }}
        isOptionEqualToValue={(option, value) => option._id === value._id}
        options={orders}
        value={
          parentOrder
            ? parentOrder
            : order && order !== ""
            ? { _id: "", orderNumber: order }
            : null
        }
        onChange={(event: any, value: any) => {
          handleChangeOrder(event, value);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            name="order"
            label={Vocabulary.order}
            variant="outlined"
            fullWidth
            onChange={(event: any) => {
              setOrder(event.target.value);
              getOrders(event.target.value === "" ? null : event.target.value);
            }}
          />
        )}
      />
    </>
  );
}
